import { List, Map,Record } from "immutable";

import { GLOBAL_FILTER_ID } from "../../../../constants/identifiers";
import createFromJS from "../../../createFromJS";
import { IdByTypeReferenceList } from "../../helper/IdByTypeReferenceList";
import { IdReferenceList } from "../../helper/IdReferenceList";
import { FilterRecord } from "./FilterRecord";
import { TimelineRangeRecord } from "./TimelineRangeRecord";
import { TreeRecord } from "./TreeRecord";

export const TimelineDataRecord = Record({
  // items records the actual structure of all items in
  // byId, and all ids in allIds
  items: new IdByTypeReferenceList(),
  superAndChildrenById: Map(),
  relationships: new IdReferenceList(),
  mindmaps: new IdReferenceList(),
  narrative: new TreeRecord(),
  sequence: List(),
  tags: Map(),
  calendarMarkers: new IdReferenceList(),
  filters: new IdReferenceList({
    allIds: List([GLOBAL_FILTER_ID]),
    byId: Map({
      GLOBAL_FILTER_ID: FilterRecord()
    })
  }),
  savedFilters: new Map(),
  dependencies: new IdReferenceList(),
  dateConstraints: new IdReferenceList(),
  attachments: new IdReferenceList(),
  timelineRange: new TimelineRangeRecord()
});

const data = {
  objects: {
    superById: "Map",
    narrative: "TreeRecord",
    sequence: "List",
    savedFilters: "Map",
    tags: "Map",
    timelineRange: "TimelineRangeRecord"
  },
  idLists: {
    relationships: "RelationshipRecord",
    mindmaps: "MindmapRecord",
    calendarMarkers: "CalendarMarkerRecord",
    filters: "FilterRecord",
    dependencies: "DependencyRecord",
    dateConstraints: "ConstraintRecord",
    attachments: "AttachmentRecord"
  },
  idByTypeLists: {
    items: "ItemRecord"
  },
  collections: {
    superAndChildrenById: "SuperAndChildrenRecord"
  }
};
createFromJS.registerCallback("TimelineDataRecord", createFromJS.createNestedCallback(TimelineDataRecord, data));
